import isMatch from 'lodash/isMatch';
import keys from 'lodash/keys';
import isFunction from 'lodash/isFunction';

export const buildEventContent = (rule, wizardValues, piggyEvent) => {
  const ruleContent = rule.content;
  const tagObj = isFunction(rule.content)
    ? ruleContent(piggyEvent, wizardValues)
    : ruleContent;

  return keys(tagObj).reduce((accu, currentTag) => {
    const tagValue = tagObj[currentTag];
    return isFunction(tagValue)
      ? {
          ...accu,
          ...{ [currentTag]: tagValue(piggyEvent, wizardValues) },
        }
      : { ...accu, ...{ [currentTag]: tagValue } };
  }, {});
};

const specsReader = (piggyEvent, wizardValues, specs) =>
  specs
    .filter((rule) =>
      isFunction(rule.eventIdentifier)
        ? rule.eventIdentifier(piggyEvent, wizardValues)
        : isMatch(piggyEvent, rule.eventIdentifier)
    )
    .map((matchedRule) => ({
      rule: matchedRule,
      content: buildEventContent(matchedRule, wizardValues, piggyEvent),
      piggyEvent,
    }));

export default specsReader;
